import { Theme } from "@material-ui/core"
import makeStyles from "@material-ui/core/styles/makeStyles"
import React, { useContext, useMemo } from "react"
import { CalendarContext } from "./context"
import Grid from "@material-ui/core/Grid"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import moment from "moment"
import "moment/locale/zh-cn"
import DateFnsUtils from "@date-io/date-fns"
import {
    KeyboardDatePicker,
    MuiPickersUtilsProvider,
} from "@material-ui/pickers"
import { generateDateRange } from "Methods/date"

moment.locale("zh-cn")

const useStyles = makeStyles((theme: Theme) => ({
    dateBtn: {
        backgroundColor: "#9c27b0",
        color: "white",
        marginRight: theme.spacing(1),
        borderRadius: "20px",
        "&:hover": {
            backgroundColor: "#9c27b0",
            boxShadow: "0 14px 26px -12px rgba(156,39,176,.42), 0 4px 23px 0 rgba(0,0,0,.12), 0 8px 10px -5px rgba(156,39,176,.2)",
        },
    },
}))

const weekTime = 7 * 24 * 3600 * 1000
const DateToolBar = () => {
    const { currentDate, backToToday, handleChangeCurrentDate } = useContext(CalendarContext)
    const classes = useStyles()
    const timeStr = useMemo(() => {
        const dateRange = generateDateRange(currentDate)
        const Monday = dateRange[0]
        const Sunday = dateRange[dateRange.length - 1]
        const inSameMonth = Monday.getMonth() === Sunday.getMonth()
        const mondayStr = moment(Monday).format("YYYY年MM月DD日")
        const sunday = moment(Sunday)
        if (inSameMonth) {
            return `${mondayStr} - ${sunday.format("DD日")}`
        } else {
            return `${mondayStr} - ${sunday.format("MM月DD日")}`
        }
    }, [currentDate])
    const currentTime = currentDate.getTime()
    const nextWeekTime = currentTime + weekTime
    const lastWeekTime = currentTime - weekTime
    const handleNextWeek = () => {
        handleChangeCurrentDate(new Date(nextWeekTime))
    }
    const handleLastWeek = () => {
        handleChangeCurrentDate(new Date(lastWeekTime))
    }
    return (
        <Grid container justify="space-between" alignItems="center">
            <Grid item>
                <Button
                    variant="contained"
                    className={classes.dateBtn}
                    onClick={backToToday}
                >
                    今天
                </Button>
                <Button
                    variant="contained"
                    className={classes.dateBtn}
                    onClick={handleLastWeek}
                >
                    上一周
                </Button>
                <Button
                    variant="contained"
                    className={classes.dateBtn}
                    onClick={handleNextWeek}
                >
                    下一周
                </Button>
            </Grid>
            <Grid item>
                <Typography color="textSecondary" variant="h5">
                    {timeStr}
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <KeyboardDatePicker
                            style={{width: 0}}
                            autoOk
                            // disableToolbar
                            variant="inline"
                            value={currentDate}
                            onChange={(value) => {
                                if (value) {
                                    handleChangeCurrentDate(value)
                                }
                            }}
                        />
                    </MuiPickersUtilsProvider>
                </Typography>
            </Grid>
            <Grid item ></Grid>
        </Grid>
    )
}

export default DateToolBar
